/**
 * Dummy Allocation Generator for Educational/Demo Purposes
 *
 * SEBI Compliance Note:
 * These are generic, illustrative allocations for educational purposes only.
 * NOT actual investment recommendations.
 * Real recommendations require proper KYC, advisory agreement, and authenticated session.
 */

export const generateDummyAllocation = (riskProfile) => {
  const templates = {
    Conservative: {
      allocations: {
        'Fixed Deposits': 40.0,
        'Debt Mutual Fund': 30.0,
        'Large Cap': 20.0,
        'Gold': 10.0
      },
      description: 'Conservative investors prioritize capital preservation with lower volatility.',
      expectedReturn: '7-9%',
      volatility: 'Low'
    },
    Moderate: {
      allocations: {
        'Large Cap': 30.0,
        'Debt Mutual Fund': 25.0,
        'Mid Cap': 20.0,
        'Fixed Deposits': 15.0,
        'Gold': 10.0
      },
      description: 'Moderate investors balance growth and stability with medium risk tolerance.',
      expectedReturn: '10-13%',
      volatility: 'Medium'
    },
    Aggressive: {
      allocations: {
        'Large Cap': 35.0,
        'Mid Cap': 25.0,
        'Small Cap': 20.0,
        'Flexi-cap Mutual Fund': 15.0,
        'Gold': 5.0
      },
      description: 'Aggressive investors seek higher growth with acceptance of higher volatility.',
      expectedReturn: '14-18%',
      volatility: 'High'
    }
  }

  const template = templates[riskProfile] || templates.Moderate

  return {
    isDemoMode: true,
    riskProfile,
    assetAllocation: template.allocations,
    description: template.description,
    expectedReturn: template.expectedReturn,
    volatility: template.volatility,
    disclaimer: {
      title: '⚠️ ILLUSTRATIVE EXAMPLE ONLY - NOT AN INVESTMENT RECOMMENDATION',
      message: 'This allocation is a generic example for educational purposes based on your risk profile. Actual investment recommendations require SEBI-compliant KYC verification, signed Investment Advisory Agreement, and active subscription to our advisory services.',
      cta: 'Sign up to receive personalized, SEBI-compliant investment recommendations.'
    }
  }
}

// Asset class descriptions for educational content
export const assetClassDescriptions = {
  'Large Cap': 'Top 100 companies by market cap per SEBI, offering stability and steady growth.',
  'Mid Cap': 'Companies ranked 101-250 by market cap with higher growth potential.',
  'Small Cap': 'Companies below 250 market cap ranking with high growth but higher volatility.',
  'Fixed Deposits': 'Bank FDs offering capital protection with moderate returns.',
  'Gold': 'Sovereign Gold Bonds with exposure to gold prices plus interest.',
  'Flexi-cap Mutual Fund': 'Diversified equity funds with flexible allocation across market caps.',
  'Debt Mutual Fund': 'Fixed income funds investing in bonds and government securities.'
}
